module.exports = {
  1: 'Enviado',
  2: 'Pendente',
  3: 'Em_Exportacao',
  4: 'ProcessadoErro',
  5: 'ProcessadoSucesso',
  6: 'Reenviado',
  7: 'Excluida',
  8: 'ComErro' || 'ErroExportacao',
  9: 'AguardandoDownload',
  10: 'PendenteProcessamento',
  11: 'ComErro' || 'ErroValidacao',
  12: 'EmValidacao',
  13: 'AguardandoDocumentos',
  14: 'ProcessadaParcialmente',
};
